import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import ru from "./locales/ru.json";
import en from "./locales/en.json";

const browserLang = navigator.language || (navigator as any).userLanguage || "";
const defaultLang = browserLang.toLowerCase().startsWith("ru") ? "ru" : "en";
const storedLang = localStorage.getItem("language");
const lng = storedLang || defaultLang;

i18n
  .use(initReactI18next)
  .init({
    resources: {
      ru: { translation: ru },
      en: { translation: en },
    },
    lng,
    fallbackLng: "en",
    supportedLngs: ["ru", "en"],
    interpolation: {
      escapeValue: false,
    },
  });

(i18n as any).on("languageChanged", (lang: string) => {
  localStorage.setItem("language", lang);
});

export default i18n;
